import { createHash } from 'crypto';

export function SHA256(plain: string): string {
  return createHash('sha256').update(plain).digest('hex');
}